export default __webpack_public_path__ + "static/media/tailwind.18b32c43.png";